document.addEventListener('alpine:init', () => {
    Alpine.data('sortableTable', (csrf, url) => ({
        csrf, url,
        draggingId: null,
        startOrder: '',

        rowFromEvent(e) {
            return e.target.closest('tr[data-id]');
        },
        rows() {
            return Array.from(this.$el.querySelectorAll('tr[data-id]'));
        },
        orderString() {
            return this.rows().map(tr => tr.dataset.id).join(',');
        },
        onDragStart(e) {
            const row = this.rowFromEvent(e);
            if (!row) return;
            this.draggingId = row.dataset.id;
            this.startOrder = this.orderString();
            try {
                e.dataTransfer.effectAllowed = 'move';
                e.dataTransfer.setData('text/plain', this.draggingId);
            } catch (_) {}
        },
        onDragOver(e) {
            if (!this.draggingId) return;
            const targetRow = this.rowFromEvent(e);
            const draggedRow = this.$el.querySelector(`tr[data-id="${this.draggingId}"]`);
            if (!targetRow || !draggedRow || targetRow === draggedRow) return;

            const rect = targetRow.getBoundingClientRect();
            const halfway = rect.top + rect.height / 2;

            if (e.clientY > halfway) {
                targetRow.after(draggedRow);
            } else {
                targetRow.before(draggedRow);
            }
        },
        async onDrop(e) {
            if (!this.draggingId) return;

            const endOrder = this.orderString();
            const original = this.startOrder;
            this.draggingId = null;

            if (endOrder === original) return;

            const payload = this.rows().map((tr, i) => ({ id: Number(tr.dataset.id), order_by: i + 1 }));

            try {
                const res = await fetch(this.url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': this.csrf,
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify({ order: payload }),
                });
                if (!res.ok) throw new Error('Failed to save order');

                const i18n = window.coreI18n || {};
                if (typeof window.showToast === 'function') {
                    showToast(i18n.sidebar_order_updated || 'Order updated', 'success');
                }
            } catch (err) {
                // revert to original order
                const ids = original.split(',').filter(Boolean);
                const byId = {};
                this.rows().forEach(tr => byId[tr.dataset.id] = tr);
                ids.forEach(id => { const r = byId[id]; if (r) this.$el.appendChild(r); });

                const i18n = window.coreI18n || {};
                const failureMsg = i18n.sidebar_order_failed || 'Could not save order';
                if (typeof window.showToast === 'function') {
                    showToast(failureMsg, 'error');
                } else {
                    alert(failureMsg);
                }
            }
        },
        onDragEnd() {
            this.draggingId = null;
        },
    }));
});
